import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import Container from "../../container";
import {
  Main,
  ContainerSpecialist,
  SubTitleSchedule,
  DivTitle,
  TitleSchedule,
  Table,
  Pagination,
  DivSelect,
  ContainerModal,
  ButtonBack,
  IconBack,
  LabelBack,
  Contacts,
  TitleContact,
  ContactsMain,
} from "./style";

import { useDispatch, useSelector } from "react-redux";

import {
  getAllDoctors,
  getAllSpecialties,
} from "../../redux/actions/specialist.actions";
import { getUnitAddress } from "./getUnits";
import { getContacts } from "./getContacts";
import Profile from "../home/profile";
import { openModalUser } from "../../redux/actions/user.actions";

function SpecialistDoctors() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [specialtySelect, setSpecialtySelect] = useState(null);
  const [visible, setVisible] = useState(false);
  const [specialistSelected, setSpecialistSelected] = useState(false);

  function changeSpecialist({ target }) {
    const specialtySelected = JSON.parse(target.value);
    setSpecialtySelect(specialtySelected);
    dispatch(getAllDoctors({ specialty: specialtySelected, page: page }));
  }

  function specialistSelect(specialist) {
    setSpecialistSelected(specialist);
    setVisible(true);
  }

  function changePage(param) {
    let paginator = page;
    if (param === 1) {
      paginator = page - 1;
      setPage(page - 1);
    } else {
      paginator = page + 1;
      setPage(page + 1);
    }
    dispatch(getAllDoctors({ page: paginator, specialty: specialtySelect }));
  }

  const specialist = useSelector((state) => state.specialists.specialistAll);
  const specialties = useSelector((state) => state.specialists.specialties);
  const modalUser = useSelector((state) => state.userReducer.modalUser);

  useEffect(() => {
    dispatch(getAllSpecialties());
    dispatch(getAllDoctors({ page: page }));
  }, []);

  return (
    <>
      <Modal
        closeTimeoutMS={500}
        overlayClassName="overlay-dialog"
        className="custom-dialog"
        isOpen={visible}
        onRequestClose={() => {
          setVisible(false);
        }}
        ariaHideApp={false}
      >
        <ContainerModal>
          <ButtonBack type="button" onClick={() => setVisible(false)}>
            <IconBack src="img/icons/back-icon.png"></IconBack>
            <LabelBack>Voltar</LabelBack>
          </ButtonBack>
          <ContactsMain>
            {specialistSelected &&
              specialistSelected.units.map((unit, key) => (
                <>
                  <Contacts>
                    <TitleContact>Endereço: </TitleContact>
                    <TitleContact>{getUnitAddress(unit.unit_id)}</TitleContact>
                  </Contacts>

                  {getContacts(unit).map((contact) => (
                    <Contacts>
                      <TitleContact>{contact.type}:</TitleContact>
                      <TitleContact>{contact.value}</TitleContact>
                    </Contacts>
                  ))}
                </>
              ))}
            {specialistSelected &&
              specialistSelected.external_offices.map((offices, key) => (
                <>
                  <Contacts>
                    <TitleContact>Endereço: </TitleContact>
                    <TitleContact>
                      {`
                  ${offices?.address}, 
                  ${offices?.number}, 
                  ${offices?.neighborhood}, 
                  ${offices?.city} - 
                  ${offices?.federated_state}`}
                    </TitleContact>
                  </Contacts>
                  <Contacts>
                    <TitleContact>Telefone: </TitleContact>
                    <TitleContact>{offices.phone_number}</TitleContact>
                  </Contacts>
                </>
              ))}
          </ContactsMain>
        </ContainerModal>
      </Modal>
      <Container>
        <Main>
          <ContainerSpecialist>
            <DivTitle>
              <TitleSchedule>Médicos Einstein</TitleSchedule>
              <SubTitleSchedule>
                Consulte os nossos especialistas do Einstein Corporate
              </SubTitleSchedule>
            </DivTitle>
            <div>
              {specialties.length > 0 && (
                <DivSelect htmlFor="selectSpecialties">
                  <select id="selectSpecialties" onChange={changeSpecialist}>
                    {(specialties || []).map((specialty, index) => {
                      return (
                        <option
                          key={index}
                          label={`${specialty.name}`}
                          value={JSON.stringify(specialty.id)}
                        />
                      );
                    })}
                  </select>
                  <img src="img/arrow-down.png" />
                </DivSelect>
              )}
            </div>
            <div>
              {specialist.length > 0 && (
                <Table>
                  <thead>
                    <tr>
                      <th>NOME</th>
                      <th>CRM</th>
                      <th>ESPECIALIDADES</th>
                      <th>CONTATO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specialist?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.name.toUpperCase()}</td>
                          <td>{item.crm}</td>
                          <td>{item.specialties + " "}</td>
                          <td
                            onClick={() => {
                              specialistSelect(item);
                            }}
                          >
                            VISUALIZAR CONTATO
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>

            <Pagination>
              {specialist.length > 8 && (
                <div>
                  <button
                    disabled={page === 0}
                    id="anterior"
                    onClick={() => {
                      changePage(1);
                    }}
                  >
                    Anterior &nbsp;
                  </button>
                  <button
                    id="proximo"
                    onClick={() => {
                      changePage(2);
                    }}
                  >
                    Próximo &nbsp;
                  </button>
                </div>
              )}
            </Pagination>
          </ContainerSpecialist>
        </Main>
        <Profile isOpen={modalUser} onClose={openModalUser} />
      </Container>
    </>
  );
}
export default SpecialistDoctors;
